import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import { DebugMode } from '../contexts';
export function i18nTeam({ sport, name, label }, debug) {
    const translation = I18nAPI.translate('teams', `${sport}-${name}`);
    if (debug) {
        return name + (translation ? '*' : '');
    }
    return translation || label || name;
}
const Team = props => {
    const debugEnabled = React.useContext(DebugMode);
    return React.createElement(React.Fragment, null, i18nTeam(props, debugEnabled));
};
export default Team;
//# sourceMappingURL=Team.js.map